export default __webpack_public_path__ + "static/media/help_btn.5544d1c8.png";